import {
  CardContent,
  Grid,
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
  withStyles,
} from "@material-ui/core";
import { isThisMinute } from "date-fns";
import React, { useEffect, useRef, useState } from "react";
import PerfectScrollbar from "react-perfect-scrollbar";
import StyledTableRow from "../../components/StyledTableRow";
import {
  convertToThousands,
  getUniqueValues,
  _isNaN,
  countOrACVFormatter,
} from "../../util/customFunctions";
import * as d3 from "d3";
import { getMixKey } from "../../util/generateHeadings";
import {
  customSortedOppType,
  customSortedSegments,
} from "../../util/customSortings";
import { deSnake } from "../../util/dataFormatter";
import { color } from "d3";
import CopyTablesObject from "../../components/xlsx-export/CopyTablesObject";
// import ExcelExportButton from "../../components/xlsx-export/xlsxexport";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import CustomWidthTooltip from "../../components/Buttons/Expand_Collapse_Tooltip";

const useStyle = makeStyles((theme) => ({
  root: {},
  sticky: {
    position: "sticky",
    left: -1,
    background: "white",
    // outline: "0.5px solid lightgrey",
    // outlineOffset: "-1.5px",
    // Create a pseudo-element for the fixed right border
    "&::after": {
      content: '""',
      position: "absolute",
      top: 0,
      bottom: 0,
      right: 0,
      width: "1.5px", // Adjust the thickness as needed
      background: "lightgrey", // Adjust the color as needed
    },
  },
  stickyHeader: {
    position: "sticky",
    top: -1,
    background: "white",
    // outline: "0.2px solid lightgrey",
    // outlineOffset: "-1.5px",
    outline: "lightgrey solid 1px",
    outlineOffset: "-1.5px",
    zIndex: 5,
    // Create a pseudo-element for the fixed right border
    "&::after": {
      content: '""',
      position: "absolute",
      top: 0,
      bottom: 0,
      right: 0,
      width: "0.5px", // Adjust the thickness as needed
      // background: "lightgrey", // Adjust the color as needed
    },
  },
  content: { width: "100%" },
  table: {
    border: "0.5px solid lightgrey",
    padding: "5px",
    color: "inherit",
  },
  repText: {
    border: "0.5px solid lightgrey",
    padding: "5px",
    color: "inherit",
    textAlign: "left",
    minWidth: "169px",
    fontWeight: "inherit",
  },
  repNumber: {
    border: "0.5px solid lightgrey",
    padding: "5px",
    color: "inherit",
    textAlign: "right",
    fontWeight: "inherit",
  },
  repNumberACV: {
    border: "0.5px solid lightgrey",
    padding: "5px",
    color: "inherit",
    textAlign: "right",
    minWidth: "92px",
    fontWeight: "inherit",
  },
  repNumberPercent: {
    border: "0.5px solid lightgrey",
    padding: "5px",
    color: "inherit",
    textAlign: "right",
    minWidth: "90px",
    fontWeight: 600,
    cursor: "pointer",
  },
  repTextH: {
    border: "0.5px solid lightgrey",
    padding: "5px",
    color: "inherit",
    textAlign: "left",
    fontWeight: 600,
  },
  repNumberH: {
    border: "0.5px solid lightgrey",
    padding: "5px",
    color: "inherit",
    textAlign: "right",
    fontWeight: 600,
  },
  tableHeader: {
    fontWeight: 600,
    border: "0.5px solid lightgrey",
    padding: "5px",
    color: "inherit",
  },
  repHeader: {
    fontWeight: 600,
    border: "0.5px solid lightgrey",
    padding: "5px",
    color: "inherit",
    width: "200px",
  },
   repCell: {
    border: "0.5px solid lightgrey",
    padding: "5px",
    color: "inherit",
    width: "200px",
  },
  inner: {
    height: 375,
    minWidth: 500,
  },
  chart: {
    height: "100%",
  },
  tableHeader: {
    fontSize: "15px",
    whiteSpace: "normal",
    textAlign: "center",
  },
  tableCell: {
    whiteSpace: "normal",
  },
  indentName: {
    paddingLeft: 30,
  },
  blackLabel: {
    color: "black",
  },
  inputFieldContainers: {
    marginBottom: 10,
    padding: 10,
    [theme.breakpoints.up("lg")]: {
      paddingRight: 0,
    },
  },
  fontBold: {
    fontWeight: 600,
  },
  stickyColumn: {
    minWidth: 200,
    left: 0,
    position: "sticky",
    zIndex: theme.zIndex.appBar + 1,
  },
}));
export default function POCTable(props) {
  const classes = useStyle();
  const tableRef = React.createRef();
  const tableContainerRef = useRef();

  const [isOverflowing, setIsOverflowing] = useState(false);
  const [rowPin, setrowPin] = useState(false);
  const [expandedRows, setExpandedRows] = useState([]);
  const [isSticky, setIsSticky] = useState(false);
  const [parentWidth, setparentWidth] = useState();
  const [isRegion, setIsRegion] = useState(true)

  const HtmlTooltip = withStyles((theme) => ({
      tooltip: {
        backgroundColor: "rgb(255,255,255,0.8)",
        color: "black",
        fontFamily: "roboto",
        fontSize: theme.typography.pxToRem(14),
        borderRadius: "1rem",
        padding: "0px",
        boxShadow: "0 0.1rem 0.1rem 0",
        marginTop: "0.4rem",
      },
    }))(Tooltip);


    const projectedYieldTooltip = (
        <>
          {Array(1)
            .fill()
            .map((item) => (
              <>
                <div
                  style={{
                    // borderTop: "solid #4471C4",
                    borderRadius: "0.3rem",
                    padding: "0px",
                    margin: 0,
                    borderWidth: "0.3rem",
                  }}
                >
                  <div className="container">
                    <Typography
                      style={{ padding: "0.1rem" }}
                      className="heading-style"
                    >{`(Attainment / Quota) / # of Reps in team`}</Typography>
                  </div>
                </div>
              </>
            ))}
        </>
      );

  let countinc = 0;
  let globalExpand = [];

  const handleExpandClick = (rowId) => {
    setExpandedRows((prevExpandedRows) => {
      const isRowExpanded = prevExpandedRows.includes(rowId);
      if (isRowExpanded) {
        return prevExpandedRows.filter((expandedRow) => expandedRow !== rowId);
      } else {
        return [...prevExpandedRows, rowId];
      }
    });
  };

  useEffect(() => {
    setExpandedRows(globalExpand);
  }, []);

  const globalExpandData = (con) => {
    if (con === true) {
      setExpandedRows(globalExpand);
      // setglobalExpandArrow(true);
      setIsRegion(true)
    } else {
      setExpandedRows([]);
      // setglobalExpandArrow(false);
      setIsRegion(false)
    }
  };

//   const quarter = props.data.filter(
//     (item) => item[props.groupBy] !== "total" && item[props.groupBy] !== null
//   );

  // const uniqueQuarters = quarter.map(item => item[props.groupBy]).filter(getUniqueValues)
  const uniqueCols = ['POCs Started', 'POCs Completed', 'Tech Wins', 'POC Win Rate', `Tech Losses`, 'POC Loss Rate', `Avg. Duration (Days)`, `# of Unique Technologies replaced`, `# in Torq Workspace (Lab)`,
    '# in Customer Workspace', '# of Unique First Competitors', '# of Unique Second Competitors'
  ];
  const uniqueQuarters = props.uniqueQuarters



  // console.log((uniqueOwner.map(owner => quarter.filter(x => x.Owner_Name === owner && x.Quota !== null).length < uniqueQuarters.length ) ))

  const ast = (x) => (
    <>
      <span>{x}</span> <span style={{ color: "#ed7d31" }}>*</span>
    </>
  );
  const ast2 = (x) => (
    <>
      <span style={{ color: "#ed7d31" }}>*</span>&nbsp; <span>{x}</span>{" "}
    </>
  );
  //     const xyz  = uniqueOwner.map(owner => quarter.filter(x => x.Owner_Name === owner && x.Quota !== null).length < uniqueQuarters.length &&  owner).filter(x => x !== false)
  //  console.log(xyz)
  useEffect(() => {
    const tableContainer = document.getElementById("myTableContainer-second");

    const handleOverflowCheck = () => {
      if (tableContainer) {
        setIsOverflowing(
          tableContainer.scrollWidth > tableContainer.offsetWidth
        );
      }
    };

    // Check for overflow initially and whenever the component updates
    handleOverflowCheck();

    // Attach a resize event listener to check for overflow when the window is resized
    window.addEventListener("resize", handleOverflowCheck);

    return () => {
      // Clean up the event listener when the component unmounts
      window.removeEventListener("resize", handleOverflowCheck);
    };
  }, []);

  useEffect(() => {
    const tableContainer = tableContainerRef.current;

    const handleScroll = () => {
      if (tableContainer.scrollLeft > 0) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }

      if (tableContainer.scrollTop > 0) {
        setrowPin(true);
      } else {
        setrowPin(false);
      }
    };

    // Attach a scroll event listener to the TableContainer
    tableContainer.addEventListener("scroll", handleScroll);

    return () => {
      // Clean up the event listener when the component unmounts
      tableContainer.removeEventListener("scroll", handleScroll);
    };
  }, [classes.sticky]);

  // useEffect(() => {
  //   // Get the width of the parent TableContainer
  //   const width = tableContainerRef.current.getBoundingClientRect().width;
  //   setparentWidth(width);
  // }, [parentWidth]);

  useEffect(() => {
  const updateWidth = () => {
    const width = tableContainerRef.current.getBoundingClientRect().width;
    setparentWidth(width);
  };

  // Initial width setting
  updateWidth();

  // Add resize event listener
  window.addEventListener('resize', updateWidth);

  // Cleanup listener on component unmount
  return () => {
    window.removeEventListener('resize', updateWidth);
  };
}, []); // empty dependency array ensures this runs once on mount and cleanup on unmount

  return (
    <div
      className={classes.root}
      style={{
        height: "100%",
        display: "flex",
        alignItems: "center",
        // width: "100%",
        justifyContent: "center",
      }}
    >
      <CardContent className={classes.content} style={{ padding: "1rem" }}>   
        <Grid container justify="flex-start" style={{ padding: "1rem" }}>
          {parentWidth !== undefined ? (
          <div
            style={{
              display: "flex",
              justifyContent: "right",
              marginBottom: "0.6rem",
              // marginRight: "1rem",
              width: `${parentWidth}px`,
            }}
          >
            <CopyTablesObject tableRef={tableRef} />
          </div>
        ) : null}
          <TableContainer
            className={classes.mainTable}
            id="myTableContainer-second"
            ref={tableContainerRef}
            style={{
              borderLeft: isSticky ? "0.5px solid lightgrey" : "",
              borderTop: rowPin ? "0.5px solid lightgrey" : "",
              maxHeight: "85vh",
              // height: "85vh",
            }}
          >

            <Table
              ref={tableRef}
              size="small"
              aria-label="html table"
              style={{ tableLayout: "auto", width: "initial" }}
              data-test={
                props.dataTest
                  ? props.dataTest
                  : "quota-attainment-detail-table"
              }
            >
              <TableHead style={{ position: "sticky", top: -1, zIndex: 5 }}>
                <TableRow
                  style={{
                    fontWeight: 600,
                    paddingLeft: 5,
                    position: "sticky",
                    outline: "lightgrey solid 0.5px",
                    outlineOffset: "-1.5px",
                  }}
                  // className={rowPin ? classes.stickyHeader : ""}
                >
                   <TableCell
                    align="center"
                    // className={`${classes.repHeader}`}
                    className={
                      isSticky
                        ? `${classes.sticky} ${classes.repHeader}`
                        : classes.repHeader
                    }
                    colSpan={1}
                    style={{
                      outline: "lightgrey solid 0.5px",
                      outlineOffset: "-1.5px",
                      background: "white",
                      width: '235px'
                    }}
                  >
                    {/* {"Rep"} */}
                    <div style={{ display: "flex" }}>
                      <div style={{ marginTop: "2.5px", marginLeft: "30px" }}>
                        {"Quarter / Month" }
                      </div>
                      
                        <>
                          <CustomWidthTooltip
                            title={"Expand All"}
                            placement="top-start"
                            style={{ marginTop: "13rem" }}
                          >
                            <KeyboardArrowDownIcon
                              onClick={() => globalExpandData(true)}
                              style={{ color: "gray" }}
                            />
                          </CustomWidthTooltip>
                          <CustomWidthTooltip
                            title={"Collapse All"}
                            placement="top-start"
                          >
                            <KeyboardArrowUpIcon
                              onClick={() => globalExpandData(false)}
                              style={{ color: "gray" }}
                            />
                          </CustomWidthTooltip>
                        </>
                     
          
                    </div>
                  </TableCell>
                  {uniqueCols.map((i, index) => {
                    return (
                      <TableCell
                        key={i}
                        align="center"
                        style={
                          index % 2 === 0
                            ? { background: "#4471c4", color: "white" }
                            : {
                                background: "#5b9bd5",
                                color: "white",
                                padding: "10px 0",
                              }
                        }
                        className={classes.repHeader}
                        colSpan={1}
                      >
                        {i}
                      </TableCell>
                    );
                  })}

                  {uniqueCols.length === 0 && (
                    <TableCell
                      rowSpan={8}
                      className={classes.repHeader}
                      style={{ width: 400, textAlign: "center" }}
                    >
                      No data available
                    </TableCell>
                  )}
                </TableRow>
              </TableHead>
              <TableBody>

                {uniqueQuarters.map((qtr, i) => {
                      globalExpand.push(i);
                      countinc = countinc + 1;
                      const qData = props.quarterData.filter(f => f.quarter === qtr)
                      const qtrData = props.data.filter(f => f.quarter === qtr)
                      const months = qtrData.map(f => f.month).filter(getUniqueValues)   


                       const d = qData
                            //   console.log(d, 'sagfugafdufgyah')

                                let noOfPOCsStarted = '-'
                                let noOfPOCsCompleted = '-'
                                let noOfTechWins = '-'
                                let noOfTechLosses = '-'
                                let avgTime = '-'
                                let noOfTechReplaced = '-'
                                let noOfComp1 = '-'
                               let noOfComp2 = '-'
                               let noOfInTorqWorkSpace ='-'
                            let noOfCustomerWorkSpace = '-'
                            let techWinRate = '0%'
                            let techLossRate = '0%'
                                

                                if(d.length > 0){
                                   
                                    noOfPOCsStarted = countOrACVFormatter(d.reduce((a,b) => a+b.noOfPOCsStarted, 0), false)
                                 noOfPOCsCompleted = countOrACVFormatter(d.reduce((a,b) => a+b.noOfPOCsCompleted, 0), false)
                                 noOfTechWins = countOrACVFormatter(d.reduce((a,b) => a+b.noOfTechWins, 0), false)
                                 techWinRate = `${Math.round(d.reduce((a,b) => a+b.techWinRate, 0) * 100)}%`
                                 techLossRate = `${Math.round(d.reduce((a,b) => a+b.techLossRate, 0) * 100)}%`
                                 noOfTechLosses = countOrACVFormatter(d.reduce((a,b) => a+b.noOfTechLosses, 0), false)
                                 noOfTechReplaced = countOrACVFormatter(d.reduce((a,b) => a+b.noOfTechReplaced, 0), false)
                                 noOfComp1 = countOrACVFormatter(d.reduce((a,b) => a+b.noOfComp1, 0), false)
                                 noOfComp2 = countOrACVFormatter(d.reduce((a,b) => a+b.noOfComp2, 0), false)
                                  noOfInTorqWorkSpace = countOrACVFormatter(d.reduce((a,b) => a+b.noOfInTorqWorkSpace, 0), false)
                                 noOfCustomerWorkSpace = countOrACVFormatter(d.reduce((a,b) => a+b.noOfCustomerWorkSpace, 0), false)
                                 avgTime = d.length > 0 ? d[0].avgTime.toFixed(1) : '-'
                                }
                        
                      return (
                        <>
                          {" "}
                          <StyledTableRow
                            key={i}
                           style={{ background: "#dae3f3" }}
                          >
                            <TableCell
                              align="left"
                              // className={`${classes.table} ${classes.repHeader}`}
                              className={
                                isSticky
                                  ? `${classes.sticky} ${classes.table} ${classes.repHeader}`
                                  : `${classes.table} ${classes.repHeader}`
                              }
                              // style={
                              //   isSticky && countinc % 2 === 0
                              //     ? {
                              //         background: "#f5f5f5",
                              //         paddingLeft: "25px",
                              //       }
                              //     : { paddingLeft: "25px" }
                              // }
                              style={
                                props.showReps === true
                                  ? { background: "#dae3f3" }
                                  : isSticky && countinc % 2 === 0
                                  ? { background: "#f5f5f5" }
                                  : {}
                              }
                              colSpan={1}
                              onClick={() => handleExpandClick(i)}
                            >
                              {/* {team} */}
                              <div style={{ display: "flex" }}>
                                {
                                  expandedRows.includes(i) ? (
                                    <KeyboardArrowUpIcon
                                      style={{ color: "gray" }}
                                    />
                                  ) : (
                                    <KeyboardArrowDownIcon
                                      style={{ color: "gray" }}
                                    />
                                  )
                                }
                                <div style={{ marginTop: "3px" }}>{qtr}</div>
                              </div>
                            </TableCell>
                                  <TableCell
                                    align="right"
                                    className={classes.repHeader}
                                    colSpan={1}
                                    style={{cursor: 'pointer'}}
                                    onClick={() => props.handleChangeLocation('drilldownOnGraph', 'POCs Started', 'POCs Started', months, [qtr])}
                                  >
                                    {noOfPOCsStarted}
                                  </TableCell>
                                   <TableCell
                                    align="right"
                                    className={classes.repHeader}
                                    colSpan={1}
                                    style={{cursor: 'pointer'}}
                                    onClick={() => props.handleChangeLocation('drilldownOnGraph', 'POCs Completed', 'POCs Completed', months, [qtr])}
                                  >
                                    {noOfPOCsCompleted}
                                  </TableCell>

                                   <TableCell
                                    align="right"
                                    className={classes.repHeader}
                                    colSpan={1}
                                   style={{cursor: 'pointer'}}
                                    onClick={() => props.handleChangeLocation('drilldownOnGraph', 'Tech Wins', 'Tech Wins', months, [qtr])}
                                  >
                                    {noOfTechWins}
                                  </TableCell>

                                   <TableCell
                                    align="right"
                                    className={classes.repHeader}
                                    colSpan={1}
                                  //  style={{cursor: 'pointer'}}
                                  //   onClick={() => props.handleChangeLocation('drilldownOnGraph', 'Tech Wins', 'Tech Wins', months, [qtr])}
                                  >
                                    {techWinRate}
                                  </TableCell>

                                   <TableCell
                                    align="right"
                                    className={classes.repHeader}
                                    colSpan={1}
                                    style={{cursor: 'pointer'}}
                                    onClick={() => props.handleChangeLocation('drilldownOnGraph', 'Tech Losses', 'Tech Losses', months, [qtr])}
                                  >
                                    {noOfTechLosses}
                                  </TableCell>

                                   <TableCell
                                    align="right"
                                    className={classes.repHeader}
                                    colSpan={1}
                                  //  style={{cursor: 'pointer'}}
                                  //   onClick={() => props.handleChangeLocation('drilldownOnGraph', 'Tech Wins', 'Tech Wins', months, [qtr])}
                                  >
                                    {techLossRate}
                                  </TableCell>

                                  <TableCell
                                    align="right"
                                    className={classes.repHeader}
                                    colSpan={1}
                                //    style={{cursor: 'pointer'}}
                                //     onClick={() => props.handleChangeLocation('drilldownOnGraph', 'won', 'Closed Won', months, [qtr])}
                                  >
                                    {avgTime}
                                  </TableCell>

                                  <TableCell
                                    align="right"
                                    className={classes.repHeader}
                                    colSpan={1}
                                     style={{cursor: 'pointer'}}
                                    onClick={() => props.handleChangeLocation('drilldownOnGraph', '# of Technologies replaced', 'POCs Completed', months, [qtr])}
                                  >
                                   {noOfTechReplaced}
                                  </TableCell>

                                   <TableCell
                                    align="right"
                                    className={classes.repHeader}
                                    colSpan={1}
                                    style={{cursor: 'pointer'}}
                                    onClick={() => props.handleChangeLocation('drilldownOnGraph', '# in Torq Workspace (Lab)', 'POCs Completed', months, [qtr])}
                                  >
                                    {noOfInTorqWorkSpace}
                                  </TableCell>

<TableCell
                                    align="right"
                                    className={classes.repHeader}
                                    colSpan={1}
                                    style={{cursor: 'pointer'}}
                                    onClick={() => props.handleChangeLocation('drilldownOnGraph', '# in Customer Workspace', 'POCs Completed', months, [qtr])}
                                  >
                                    {noOfCustomerWorkSpace}
                                  </TableCell>
                                  <TableCell
                                    align="right"
                                    className={classes.repHeader}
                                    colSpan={1}
                                    style={{cursor: 'pointer'}}
                                    onClick={() => props.handleChangeLocation('drilldownOnGraph', '# of First Competitors', 'POCs Completed', months, [qtr])}
                                  >
                                    {noOfComp1}
                                  </TableCell>
                                  <TableCell
                                    align="right"
                                    className={classes.repHeader}
                                    colSpan={1}
                                    style={{cursor: 'pointer'}}
                                    onClick={() => props.handleChangeLocation('drilldownOnGraph', '# of Second Competitors', 'POCs Completed', months, [qtr])}
                                  >
                                    {noOfComp2}
                                  </TableCell>
                                 
                            

              
                          </StyledTableRow>
                            {expandedRows.includes(i) &&
                                                  
                                                         months.map((month, i) => {
                                                           countinc = countinc + 1;
                                                           const monthsData = qtrData.filter(f => f.month === month)
                                                           // console.log(reps,team, repData, repsData, 'REPPPPDATA')

                                                             const d = monthsData
                                                      let noOfPOCsStarted = '-'
                                let noOfPOCsCompleted = '-'
                                let noOfTechWins = '-'
                                let noOfTechLosses = '-'
                                let avgTime = '-'
                                let noOfTechReplaced = '-'
                                let noOfComp1 = '-'
                                let noOfComp2 = '-'
                                let noOfInTorqWorkSpace ='-'
                                let noOfCustomerWorkSpace = '-'
                                let techWinRate = '0%'
                            let techLossRate = '0%'
                                

                                if(d.length > 0){
                                   
                                      noOfPOCsStarted = countOrACVFormatter(d.reduce((a,b) => a+b.noOfPOCsStarted, 0), false)
                                 noOfPOCsCompleted = countOrACVFormatter(d.reduce((a,b) => a+b.noOfPOCsCompleted, 0), false)
                                 noOfTechWins = countOrACVFormatter(d.reduce((a,b) => a+b.noOfTechWins, 0), false)
                                 noOfTechLosses = countOrACVFormatter(d.reduce((a,b) => a+b.noOfTechLosses, 0), false)
                                  techWinRate = `${Math.round(d.reduce((a,b) => a+b.techWinRate, 0) * 100)}%`
                                 techLossRate = `${Math.round(d.reduce((a,b) => a+b.techLossRate, 0) * 100)}%`
                                 noOfTechReplaced = countOrACVFormatter(d.reduce((a,b) => a+b.noOfTechReplaced, 0), false)
                                 noOfComp1 = countOrACVFormatter(d.reduce((a,b) => a+b.noOfComp1, 0), false)
                                 noOfComp2 = countOrACVFormatter(d.reduce((a,b) => a+b.noOfComp2, 0), false)
                                 noOfInTorqWorkSpace = countOrACVFormatter(d.reduce((a,b) => a+b.noOfInTorqWorkSpace, 0), false)
                                 noOfCustomerWorkSpace = countOrACVFormatter(d.reduce((a,b) => a+b.noOfCustomerWorkSpace, 0), false)
                                 avgTime = d.length > 0 ? d[0].avgTime.toFixed(1) : '-'
                                }
                                                          
                                                                 // console.log(props.data.filter(item => item.Owner_Name === owner).map(item => item.Quota)[0] === 0)
                                                               
                                                           return (
                                                             <StyledTableRow key={i}>
                                                               <TableCell
                                                                 align="left"
                                                                 // className={`${classes.table} ${classes.indentName}`}
                                                                 className={
                                                                   isSticky
                                                                     ? `${classes.sticky} ${classes.table} ${classes.indentName}`
                                                                     : `${classes.table} ${classes.indentName}`
                                                                 }
                                                                 style={
                                                                   isSticky && countinc % 2 === 1
                                                                     ? {
                                                                         background: "#f5f5f5",
                                                                        paddingLeft: "25px",
                                                                        whiteSpace: "nowrap",
                                                                       }
                                                                     : { paddingLeft: "25px",whiteSpace: "nowrap" }
                                                                 }
                                                                 colSpan={1}
                                                               >
                                                                 {month}
                                                               </TableCell>
                                                              
                                  <TableCell
                                    align="right"
                                    className={classes.repCell}
                                    colSpan={1}
                                    style={{cursor: 'pointer'}}
                                     onClick={() => props.handleChangeLocation('drilldownOnGraph', 'POCs Started', 'POCs Started', [month], [qtr])}
                                  >
                                    {noOfPOCsStarted}
                                  </TableCell>
                                   <TableCell
                                    align="right"
                                    className={classes.repCell}
                                    colSpan={1}
                                     style={{cursor: 'pointer'}}
                                    onClick={() => props.handleChangeLocation('drilldownOnGraph', 'POCs Completed', 'POCs Completed', [month], [qtr])}
                                  >
                                    {noOfPOCsCompleted}
                                  </TableCell>
                                   <TableCell
                                    align="right"
                                    className={classes.repCell}
                                    colSpan={1}
                                     style={{cursor: 'pointer'}}
                                    onClick={() => props.handleChangeLocation('drilldownOnGraph', 'Tech Wins', 'Tech Wins', [month], [qtr])}
                                  >
                                    {noOfTechWins}
                                  </TableCell>

                                   <TableCell
                                    align="right"
                                    className={classes.repCell}
                                    colSpan={1}
                                    //  style={{cursor: 'pointer'}}
                                    // onClick={() => props.handleChangeLocation('drilldownOnGraph', 'Tech Wins', 'Tech Wins', [month], [qtr])}
                                  >
                                    {techWinRate}
                                  </TableCell>

                                   <TableCell
                                    align="right"
                                    className={classes.repCell}
                                    colSpan={1}
                                     style={{cursor: 'pointer'}}
                                    onClick={() => props.handleChangeLocation('drilldownOnGraph', 'Tech Losses', 'Tech Losses', [month], [qtr])}
                                  >
                                    {noOfTechLosses}
                                  </TableCell>

                                   <TableCell
                                    align="right"
                                    className={classes.repCell}
                                    colSpan={1}
                                    //  style={{cursor: 'pointer'}}
                                    // onClick={() => props.handleChangeLocation('drilldownOnGraph', 'Tech Wins', 'Tech Wins', [month], [qtr])}
                                  >
                                    {techLossRate}
                                  </TableCell>

                                  <TableCell
                                    align="right"
                                    className={classes.repCell}
                                    colSpan={1}
                                    // style={{cursor: 'pointer'}}
                                    // onClick={() => props.handleChangeLocation('drilldownOnGraph', 'won', 'Closed Won', [month], [qtr])}
                                  >
                                    {avgTime}
                                  </TableCell>

                                  <TableCell
                                    align="right"
                                    className={classes.repCell}
                                    colSpan={1}
                                    style={{cursor: 'pointer'}}
                                    onClick={() => props.handleChangeLocation('drilldownOnGraph', '# of Technologies replaced', 'POCs Completed', [month], [qtr])}
                                  >
                                    {noOfTechReplaced}
                                  </TableCell>

                                   <TableCell
                                    align="right"
                                    className={classes.repCell}
                                    colSpan={1}
                                    style={{cursor: 'pointer'}}
                                    onClick={() => props.handleChangeLocation('drilldownOnGraph', '# in Torq Workspace (Lab)', 'POCs Completed', [month], [qtr])}
                                  >
                                    {noOfInTorqWorkSpace}
                                  </TableCell>

                                   <TableCell
                                    align="right"
                                    className={classes.repCell}
                                    colSpan={1}
                                    style={{cursor: 'pointer'}}
                                    onClick={() => props.handleChangeLocation('drilldownOnGraph', '# in Customer Workspace', 'POCs Completed', [month], [qtr])}
                                  >
                                    {noOfCustomerWorkSpace}
                                  </TableCell>

                                   <TableCell
                                    align="right"
                                    className={classes.repCell}
                                    colSpan={1}
                                    style={{cursor: 'pointer'}}
                                    onClick={() => props.handleChangeLocation('drilldownOnGraph', '# of First Competitors', 'POCs Completed', [month], [qtr])}
                                  >
                                    {noOfComp1}
                                  </TableCell>

                                   <TableCell
                                    align="right"
                                    className={classes.repCell}
                                    colSpan={1}
                                    style={{cursor: 'pointer'}}
                                    onClick={() => props.handleChangeLocation('drilldownOnGraph', '# of Second Competitors', 'POCs Completed', [month], [qtr])}
                                  >
                                    {noOfComp2}
                                  </TableCell>

                              
                                 
                                 

                             
                                              
                                                             </StyledTableRow>
                                                           );
                                                         })
                                                         
                                                        }
                                                       
                                                     
                        </>
                      );
                    })
                 
                }
               
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>

     
      </CardContent>
    </div>
  );
}
